import { NotificationUtil } from "../types";
import { notifications } from "@mantine/notifications";

const showNotifications = ({
	successNotification = true,
	position = "bottom-right",
	color,
	title,
	autoClose = 1000,
	className,
	message,
}: NotificationUtil) => {
	if (!message || !title) {
		console.error("Notification should have message or title");

		return;
	}

	let colorNotification = "";

	if (color) {
		colorNotification = color;
	} else {
		colorNotification = successNotification ? "green" : "red";
	}

	setTimeout(() => {
		notifications.show({
			id: new Date().getTime().toString(),
			title,
			autoClose,
			position,
			className,
			color: colorNotification,
			message,
			styles: () => ({
				root: {
					backgroundColor: "white",
					border: "1px solid #D1E3DD",
					borderRadius: "8px",
					boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
					padding: "16px",
					maxWidth: "340px",
				},
				title: {
					fontWeight: 600,
					fontSize: "14px",
					color: "#1A1A1A",
					marginBottom: "4px",
				},
				description: {
					fontSize: "13px",
					color: "#555",
				},
				closeButton: {
					color: "#999",
					"&:hover": {
						backgroundColor: "#f5f5f5",
					},
				},
				icon: {
					backgroundColor: "#D1E3DD",
					borderRadius: "50%",
					width: 24,
					height: 24,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				},
			}),
		});
	}, 0);
};

const cleanNotification = () => {
	notifications.clean();
	notifications.cleanQueue();
};

export { cleanNotification, showNotifications };
